import React, {Component} from 'react';
import {connect} from 'react-redux';
import Support from '../components/support/Support'
import { browserHistory } from 'react-router';
import {AlertList} from 'react-bs-notifier';
import {removeNotification, removeAllNotifications} from '../actions/index'

class SupportContainer extends Component {

    close = () => {
        this.props.dispatch(removeAllNotifications())
        browserHistory.push('/dashboard')
    }

    render() {

        return (
            <div className="support-container">

                <AlertList
                    timeout={4000}
                    alerts={this.props.notifications || []}
                    onDismiss={(alert) => {this.props.dispatch(removeNotification(alert))}}
                />

                <h2 className="header-h2">SUPPORT</h2>
                <h3 className="header-h3">Engine Testing Management System</h3>

                <Support dispatch={this.props.dispatch} close={this.close} loading={this.props.loading} />

            </div>
        );
    }
}

export default SupportContainer = connect(state => {

    return {
        loading: (state.data || {}).loading || {},
        notifications: (state.data || {}).notifications
    }
})(SupportContainer);




// WEBPACK FOOTER //
// ./src/containers/SupportContainer.jsx